<template>
    <div class="col-12 col-lg-8 offset-0 offset-lg-2">
        <div class="account__card account__card--shadow account__card--border-bottom px-4">
            <div class="account__border">
                <div class="account__card--topbar account__card--topbar--padding d-flex align-items-start">
                    <h3 class="text--green font-weight-bold">{{ $t("resetPassword.chooseNewPassword") }}</h3>
                </div>
            </div>
            <div>
                <div class="account__border py-4">
                    <div class="account--padding">
                        <div class="row">
                            <div class="col-12 mb-2">
                                <div class="mb-2" style="position: relative;">
                                    <div>{{ $t("resetPassword.newPassword") }}</div>
                                    <input
                                        ref="new_password"
                                        class="input"
                                        :class="{'input--error': checkInput('new_password')}"
                                        v-model="newPassword"
                                        @input="checkForm()"
                                        @change="checkForm()"
                                        @submit="submitForm"
                                        name="new_password"
                                        type="password"
                                        placeholder="******"
                                    >
                                    <i
                                        @click="toggleVisibility('eyeNewPassword', 'new_password')"
                                        class="fas fa-eye input--icon cursor-pointer"
                                        :class="{ 'text--green' : eyeNewPassword }"
                                    ></i>
                                </div>
                                <section style="display: flex; flex-direction: column;">
                                    <small
                                        v-for="error in newPasswordValidationErrors"
                                        v-text="error.errorMessage"
                                        class="text-danger"
                                    ></small>
                                </section>

                                <div style="position: relative;">
                                    <div>{{ $t("resetPassword.reenterPassword") }}</div>
                                    <input
                                        ref="new_password_confirm"
                                        class="input"
                                        :class="{'input--error': checkInput('new_password_confirm')}"
                                        v-model="newPasswordConfirm"
                                        @input="checkForm()"
                                        @change="checkForm()"
                                        @submit="submitForm"
                                        type="password"
                                        placeholder="******"
                                    >
                                    <i
                                        @click="toggleVisibility('eyeNewPasswordConfirm', 'new_password_confirm')"
                                        class="fas fa-eye input--icon cursor-pointer"
                                        :class="{ 'text--green' : eyeNewPasswordConfirm }"
                                    ></i>
                                </div>
                                <section style="display: flex; flex-direction: column;">
                                    <small
                                        v-for="error in newPasswordConfirmationValidationErrors"
                                        v-text="error.errorMessage"
                                        class="text-danger"
                                    ></small>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="account__card--bottom-bar align-items-center py-3">
                    <a
                        href="/"
                        class="button button--clear m-0"
                    >{{ $t("myAccount.cancel") }}
                    </a>
                    <button @click="submitForm" class="button-brekz button-brekz--rounded button-brekz--xl m-0 button-brekz--green">
                        <span>{{ $t("myAccount.save") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import validationRules from '../js/validation/rules';

export default {
    name: "NewPassword",
    props: {
        isMobile: Boolean,
        serverSideValidationErrors: {
            type: Array,
            default: [],
            required: false,
        }
    },
    components: {},
    data() {
        return {
            isLoading: true,
            errorBag: [],
            isSubmitting: false,
            errorText: '',
            showErrorModal: false,
            newPassword: '',
            newPasswordConfirm: '',
            eyeNewPassword: false,
            eyeNewPasswordConfirm: false
        };
    },
    methods: {
        checkForm() {
            let success = true;
            this.errorBag = [];

            if (! validationRules.password(this.newPassword)) {
                success = false;

                this.errorBag.push({
                    "fieldName": "new_password",
                    "errorMessage": this.$t('myAccount.errorPassword')
                });
            }

            if (this.newPassword !== this.newPasswordConfirm) {
                success = false;

                this.errorBag.push(
                    {
                        "fieldName": "new_password_confirm",
                        "errorMessage": this.$t('resetPassword.passwordsDontMatchError')
                    }
                );
            }

            return success;
        },
        submitForm(event) {
            event.preventDefault();

            if (! this.checkForm()) {
                return;
            }

            event.target.closest('form').submit();
        },
        checkInput(inputName) {
            for(let i = 0; i < this.errorBag.length; i++) {
                if (this.errorBag[i].fieldName === inputName) {
                    return true;
                }
            }

            return false;
        },
        toggleVisibility(eyeStateVariableName, inputFieldRef) {
            this[eyeStateVariableName] = !this[eyeStateVariableName];

            this.$refs[inputFieldRef].type = this[eyeStateVariableName] ? 'text' : 'password';
        }
    },
    mounted() {
        this.errorBag = this.serverSideValidationErrors.map((error) => ({
            "fieldName": "new_password",
            "errorMessage": error
        }));
    },
    computed: {
        newPasswordValidationErrors() {
            return this.errorBag.filter((value) => value.fieldName === 'new_password');
        },
        newPasswordConfirmationValidationErrors() {
            return this.errorBag.filter((value) => value.fieldName === 'new_password_confirm');
        }
    }
};
</script>
